/** Forma da falha do axios que interessa às telas de autenticação. */
interface ApiErrorShape {
  response?: { status?: number; data?: { error?: string } };
  message?: string;
}

function asApiError(err: unknown): ApiErrorShape {
  return (err ?? {}) as ApiErrorShape;
}

/**
 * Mensagem que o backend mandou, com recuo para um texto próprio.
 *
 * Sem isto sobraria `err.message`, que em erro HTTP é só "Request failed with
 * status code 403" — inútil para quem precisa saber que a conta não foi confirmada.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const e = asApiError(err);
  return e.response?.data?.error || e.message || fallback;
}

/** Código HTTP da falha, quando houver. */
export function apiErrorStatus(err: unknown): number | undefined {
  return asApiError(err).response?.status;
}
